export default () => ({
  summaryContainer: {
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    whiteSpace: 'break-spaces',
  },
});
